export const on = (selector, eventType, childSelector, eventHandler) => {
  const elements =
    typeof selector === 'string'
      ? document.querySelectorAll(selector)
      : selector
  if (elements.length > 1) {
    for (element of elements) {
      element.addEventListener(eventType, (eventOnElement) => {
        if (eventOnElement.target.matches(childSelector)) {
          eventHandler(eventOnElement)
        }
      })
    }
  }
  else {
    elements.addEventListener(eventType, (eventOnElement) => {
      if (eventOnElement.target.matches(childSelector)) {
        eventHandler(eventOnElement)
      }
    })
  }
}

export const once = (object, event, callback) => {
  const handle = {}

  const eventNames = event.split(' ')

  const cbWrapper = function () {
    eventNames.forEach(function (e) {
      object.removeEventListener(e, cbWrapper, false)
    })
    callback.apply(this, arguments)
  }

  eventNames.forEach(function (e) {
    object.addEventListener(e, cbWrapper, false)
  })

  handle.cancel = function () {
    eventNames.forEach(function (e) {
      object.removeEventListener(e, cbWrapper, false)
    })
  }

  return handle
}

export const delegate = (selector, event, callback) => {
  document.documentElement.addEventListener(event, function (e) {
    for (
      let target = e.target;
      target && target != this;
      target = target.parentNode
    ) {
      if (target.matches(selector)) {
        callback.call(target, e)
        break
      }
    }
  })
}

export const dispatch = (elem, name, detail = false) => {
  const event = new CustomEvent(name, { bubbles: false, detail });
  elem.dispatchEvent(event);
}